module.exports = __webpack_public_path__ + "bg-perguntas--1c1fd8de.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/bg-perguntas.jpg
// module id = 249
// module chunks = 0